import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { catchError, of, switchMap, withLatestFrom } from 'rxjs';
import { PersonalInfoService } from '../services/personal-info.service';
import * as PersonalInfoActions from './personal-info.actions';
import { selectUser } from '@/app/dashboard/store/dashboard.selectors';
import * as DashboardActions from '@/app/dashboard/store/dashboard.actions';

@Injectable()
export class PersonalInfoEffects {
  private readonly actions$ = inject(Actions);
  private readonly service = inject(PersonalInfoService);
  private readonly store = inject(Store);
  private readonly translate = inject(TranslateService);

  submitProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PersonalInfoActions.updateProfile),
      withLatestFrom(this.store.pipe(select(selectUser))),
      switchMap(([{ profile }, currentProfile]) => {
        return this.service
          .completeProfile(currentProfile?.id ?? '', profile)
          .pipe(
            switchMap(res => {
              const updated = res?.data;
              if (!updated) {
                return [
                  PersonalInfoActions.updateProfileFailure({
                    error: this.translate.instant(
                      'accountSettings.personalInfo.errors.saveFailed'
                    ),
                  }),
                ];
              }
              return [
                PersonalInfoActions.updateProfileSuccess({ profile: updated }),
                DashboardActions.loadUserSuccess({ user: updated }),
              ];
            }),
            catchError(err =>
              of(
                PersonalInfoActions.updateProfileFailure({
                  error:
                    err?.error?.message ||
                    this.translate.instant(
                      'accountSettings.personalInfo.errors.saveFailed'
                    ),
                })
              )
            )
          );
      })
    )
  );
}
